var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSortAscending = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 28.19 53.27"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#4d4f5c",
  stroke: "#4d4f5c",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m14.07 1 6.53 11.32 6.53 11.31H1l6.53-11.31L14.07 1z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#4d4f5c",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M14.12 52.27 7.59 40.95 1.06 29.63H27.19l-6.53 11.32-6.54 11.32z"
})));
export { SvgSortAscending as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDI4LjE5IDUzLjI3Ij48cG9seWdvbiBwb2ludHM9IjE0LjA3IDEgMjAuNiAxMi4zMiAyNy4xMyAyMy42MyAxNC4wNyAyMy42MyAxIDIzLjYzIDcuNTMgMTIuMzIgMTQuMDcgMSIgZmlsbD0iIzRkNGY1YyIgc3Ryb2tlPSIjNGQ0ZjVjIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiIvPjxwb2x5Z29uIHBvaW50cz0iMTQuMTIgNTIuMjcgNy41OSA0MC45NSAxLjA2IDI5LjYzIDE0LjEyIDI5LjYzIDI3LjE5IDI5LjYzIDIwLjY2IDQwLjk1IDE0LjEyIDUyLjI3IiBmaWxsPSJub25lIiBzdHJva2U9IiM0ZDRmNWMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIi8+PC9zdmc+";